import { Box, SectionHeading } from "@hightouch/htui";

export const FKHeading = ({ title }: { title?: string }) => {
  return (
    <Box bg="gray.300" p={6} borderRadius="md">
      <SectionHeading>{title}</SectionHeading>
    </Box>
  );
};
